import { Component, OnInit, DestroyRef, ChangeDetectorRef, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, NavigationEnd, RouterLinkActive, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';

import { NavElement, urluriDin } from '../nav-left.model';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';

// Un element din meniul din stanga: legatura sau grup (se afiseaza recursiv).
@Component({
    selector: 'app-nav-element',
    templateUrl: './nav-element.component.html',
    styleUrls: ['./nav-element.component.scss'],
    imports: [MatRipple, MatIcon, RouterLinkActive, RouterLink]
})
export class NavElementComponent implements OnInit {
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private cd = inject(ChangeDetectorRef);


  readonly element = input.required<NavElement>();
  readonly nivel = input(0);

  deschis = false;
  contineRutaCurenta = false;
  private caleCurenta = '';

  ngOnInit() {
    if (!this.element().copii) {
      return;
    }
    // grupul se deschide singur cand pagina curenta e in el si se inchide la navigarea pe alta pagina;
    // schimbarile doar de query params (filtre) nu ating grupurile deschise manual
    this.sincronizeazaCuRuta();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.sincronizeazaCuRuta();
      this.cd.markForCheck();
    });
  }

  comuta() {
    this.deschis = !this.deschis;
  }

  private sincronizeazaCuRuta() {
    const cale = this.router.url.split(/[?#;]/)[0];
    if (cale === this.caleCurenta) {
      return;
    }
    this.caleCurenta = cale;
    this.contineRutaCurenta = urluriDin(this.element()).some(url => cale === url || cale.startsWith(url + '/'));
    this.deschis = this.contineRutaCurenta;
  }

}
